module.exports = __webpack_public_path__ + "static/media/rating-star-empty.b471afcd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/rating-star-empty.svg
// module id = 683
// module chunks = 0